import { render, staticRenderFns } from "./type6.vue?vue&type=template&id=0a9be5d6&scoped=true&"
import script from "./type6.vue?vue&type=script&lang=js&"
export * from "./type6.vue?vue&type=script&lang=js&"
import style0 from "./type6.vue?vue&type=style&index=0&id=0a9be5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9be5d6",
  null
  
)

export default component.exports